import {Entity} from "../domain/entities/entity";
import {PropertyInfo} from "../types/property-info.type";
import {PROPERTY_INFO} from "../symbols";

export function typeInfo(propertyInfo: PropertyInfo) {

    return function <TEntity extends Entity>(target: TEntity, propertyKey: Extract<keyof TEntity, string | symbol>): void {
        Reflect.defineMetadata(PROPERTY_INFO, propertyInfo, target.constructor, propertyKey);
    }

}